/* eslint-disable react/prop-types */
/* eslint-disable react/function-component-definition */

import { useEffect, useState } from "react";
import { Link } from "react-router-dom";

// Custom Components
import MDBox from "components/MDBox";
import Author from "components/Table/Author";

// 3rd party library
import moment from "moment";

// MUI Components
import { IconButton } from "@mui/material";

// Constants
import Constants, { Icons, defaultData } from "utils/Constants";
import { formatDuration } from "utils/methods/methods";

export default function ProjectMapActivityData(activityList) {
  const [rows, setRows] = useState([]);

  useEffect(() => {
    if (Array.isArray(activityList) && activityList.length > 0) {
      // sort activity list by end time without mutating source
      const sortedActivityList = [...activityList].sort(
        (a, b) => new Date(b.activityEndDateTime) - new Date(a.activityEndDateTime)
      );
      const list = sortedActivityList.map((item, index) => {
        const temp = {
          srNo: <Author name={index + 1} />,
          team: <Author name={item?.teamName} />,
          activity: <Author name={item?.activityName} />,
          endTime: (
            <Author
              name={moment(item?.activityEndDateTime).format(
                defaultData.WEB_24_HOURS_FORMAT_WITHOUT_SECOND
              )}
            />
          ),
          duration: <Author name={formatDuration(item?.durationFormatted)} />,
          comments: <Author name={item?.description} />,
          action: (
            <MDBox>
              <IconButton
                aria-label="fingerprint"
                color="info"
                component={Link}
                to={`/client/shifts/shift-details/${item?.[Constants.MONGOOSE_ID]}`}
                target="_blank"
                rel="noopener noreferrer"
              >
                {Icons.VIEW}
              </IconButton>
            </MDBox>
          ),
        };
        return temp;
      });
      setRows(list);
    } else {
      setRows([]);
    }
  }, [activityList]);

  const activityColumns = [
    { Header: "No.", accessor: "srNo", width: "2%" },
    { Header: "Team", accessor: "team", align: "left", width: "18%" },
    { Header: "Activity", accessor: "activity", align: "left", width: "25%" },
    { Header: "End Time", accessor: "endTime", align: "left", width: "32%" },
    { Header: "Duration", accessor: "duration", align: "left", width: "7%" },
    { Header: "Descriptions", accessor: "comments", align: "left" },
    { Header: "Action", accessor: "action", width: "10%", align: "left" },
  ];

  const tableData = {
    activityColumns,
    activityRows: rows,
  };

  return tableData;
}
